import React from 'react';

import { CloudAccountInfoGetResponse } from '@ariksa/jit/api';
import { colorOpacity, customTheme } from 'theme';

import { StackedHeader } from 'components/DataDisplay';
import { useCloudAccountId } from 'containers/Setup/CloudAccounts/utils';

interface Props {
  account: CloudAccountInfoGetResponse;
  label: string;
  icon: React.ReactNode;
  dataGroupName?: string;
  iconColor?: string;
  iconBg?: string;
}

export const JITConfigurationModalHeader = (props: Props) => {
  const { account, label, icon, dataGroupName, iconColor, iconBg } = props;
  const { toCloudAccountName } = useCloudAccountId();

  return (
    <StackedHeader
      upper={label}
      lower={
        dataGroupName ??
        toCloudAccountName(account.uuid) + ': ' + account.cloud_account_id
      }
      icon={icon}
      useCustomColor
      color={iconColor ?? customTheme.colors.blue['400']}
      bg={colorOpacity(iconBg ?? customTheme.colors.blue['400'], 0.2)}
      border={false}
    />
  );
};
